import { OrderDetails } from '@nemuru-eng/js-api-client';

import { OrderTable } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/OrderTable';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';

export const OrderLines = ({ orderDetails }: { orderDetails: OrderDetails }) => {
  return (
    <>
      <SubSectionWrapper title={'ORDER_LINES'}>
        <OrderTable orderDetails={orderDetails} />
      </SubSectionWrapper>
    </>
  );
};
